import styled from 'styled-components'

export const Container = styled.div`
  height: 100vh;
  position: relative;
  overflow-x: hidden;
  background: #F5F4F4;
  display: block;
  flex-direction: column;
  align-items: center;

  .headerMain{
    background: #1C2937;
    height: 60px;

    > div {
      height: inherit;
      width: 100%;
      display: flex;
      max-width: 68%;
      margin: 0 auto;

      .headerLeft {
        display: flex;

        .divLogo {
          width: 100px;
          min-width: max-content;
          display: flex;

          img {
            width: inherit;
            margin: auto 5px;
          }
        }
        
        .divActions {
          flex: 1 1 0%;
          align-items: center;
          display: contents;

          a {
            text-decoration: none;
            height: 35px;
            text-align: center;
            margin: auto 5px;
            width: 165px;
            display: flex;

            span {
              font-size: 14px;
              color: rgb(255, 255, 255);
              font-weight: 500;
              display: block;
              margin: auto;
            }
          }
        }
      }

      .headerRight {
        display: flex;
        flex: 1;
        justify-content: flex-end;
        align-items: center;
        gap: 5px;
      }

    }

    .headerButtonLancamento {
      justify-content: center;
      align-items: center;
      background-color: rgb(140, 36, 88);
      border-radius: 8px;
      padding-left: 5px;
      padding-right: 5px;
      width: 90px;

      > div {
       display: flex;
       gap: 5px;
      }
    }
  
    /* sm */
    @media (min-width: 600px) and (max-width: 768px) {
      height: 50px;
      
      > div {
        max-width: 100%;

        .headerLeft {
          .divLogo{
            width: 60px;
          }
          .divActions {

            > div {
              width: 100px;

              button{
                font-size: 10px;
              }
            }
                        
            a {
              margin: auto 2px;
              width: 90px;

              span {
                font-size: 10px;
              }
            }
          }
        }
      }

      .headerButtonLancamento {
          width: 100px !important;
      }

    }

    /* md */
    @media (min-width: 768px) and (max-width: 1025px) {
      height: 55px;

      > div {
        max-width: 77%;
        min-width: 768px;

        .headerLeft {
          .divLogo{
            width: 80px;
          }
          .divActions {

            > div {
              width: 100px;

              button{
                font-size: 11.5px;
              }
            }
                        
            a {
              margin: auto 2px;
              width: 90px;

              span {
                font-size: 11.5px;
              }
            }
          }
        }
      }

      .headerButtonLancamento {
          width: 100px !important;
      }

    }

    /* lg */
    @media (min-width: 1025px) and (max-width: 1280px) {
    
      > div {
        max-width: 70%;
        min-width: 1025px;

        .headerLeft {
          .divLogo{
            width: 80px;
          }
          .divActions {

            > div {
              button{
                font-size: 12.5px;
              }
            }
                        
            a {
              span {
                font-size: 12.5px;
              }
            }

          }
        }

      }
    
    }

    /* xl */
    @media (min-width: 1280px) and (max-width: 1536px) { 
    
      > div {
        max-width: 85%;
        min-width: 1280px;
      }
    
    }

    /* 2xl */
    @media (min-width: 1536px) { 
      > div {
        min-width: 1350px;
      }
    }

  }
    
  .wave{
    position: absolute;
    z-index: -1;
    top: -45px;
    /* right: 10px; */
  }

  .home-text{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    /* margin-top: 1.2rem; */
    margin-top: 0.1rem;
    text-align: center;
  }

  .home-text-title{
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    h1{
      font-weight: 700;
      font-size: 3rem;
      color: var(--white);
      text-align: center;
      margin-top: 1.4rem;
      margin-left: 3rem;
      width: 450px;
    }

    .home-text-icon{
      margin-left: 0.4rem;
      margin-top: 1.6rem;

    }
  }

  h4{
    font-weight: 600;
    font-size: 1.5rem;
    color: var(--white);
  }

  .category-farm-dropdown{
      font-size: 28px;
      font-weight: 700;
      color: var(--black);
      text-decoration: none;
    }

  .layout-menu{
    display: flex;
    align-items: center;
    padding-left: 1.6rem;
    position: absolute;
    background: var(--gray-100);
    width: 423px;
    height: 65px;
    right: 13px;
    top: 88px;
    border-radius: 20px;
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
    transition: filter 0.2s;

    z-index: 2;

    :hover{
      filter: brightness(0.9);
    }

    

    img{
      position: absolute;
      right: 17px;
      bottom: 19px;
    }
  }

  .menu-overlay{
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    cursor: auto;

    z-index: 1;
  }`
